<div
  [@smoothEnter]
  class="notification"
  [ngClass]="'notification--' + type"
  [class.notification--compact]="compact"
  [class.notification--toast]="toast"
>
  <ftr-icon class="notification__icon" [icon]="getIcon()" align="Middle" />
  @if (markdown) {
    <span markdown class="notification__message" [renderAllBreaks]="true">
      <ng-container *ngTemplateOutlet="content" />
    </span>
  } @else {
    <span class="notification__message">
      <ng-container *ngTemplateOutlet="content" />
    </span>
  }
</div>

<ng-template #content>
  <ng-content />
</ng-template>
